import { HttpClient, HttpParams } from '@angular/common/http';
import {} from '@angular/common/http/testing';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SystemMessageService } from 'app/core/system-message/system-message-service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'pcg-upload-button',
    templateUrl: './upload-button.component.html',
    styleUrls: ['./upload-button.component.scss'],
    standalone: false
})
export class UploadButtonComponent implements OnInit {
	@Input() uploadUrl: string;
	@Input() submitUrl: string;
	// Optional; when set, a Remove button lets the user discard the staged
	// file instead of submitting it
	@Input() deleteUrl: string;
	@Input() fileName: string;
	@Input() id: number;
	@Output() updateTable = new EventEmitter<any>();

	subscriptions: Subscription = new Subscription();

	constructor(private messageService: SystemMessageService, private httpClient: HttpClient) { }

	ngOnInit() {
	}

	UploadFile(target: HTMLInputElement) {
		if (target.files.length === 0) {
			return;
		}

		const uploadData: FormData = this.GetUploadData(target);
		this.subscriptions.add(
			this.httpClient
				.post<any>(this.uploadUrl + `/?id=${this.id}`, uploadData)
				.subscribe(result => {
					this.ApiReturn(result);
				})
		);
		target.value = null;
	}

	SubmitFile() {
		let params = new HttpParams()
			.set('id', this.id.toString())
			.set('fileName', this.fileName);
		this.subscriptions.add(
			this.httpClient.get(this.submitUrl, { params: params }).subscribe(_ => {
				this.updateTable.emit();
			})
		);
	}

	RemoveFile() {
		if (!confirm(`Remove the staged file '${this.fileName}'? It has not been submitted and will be discarded.`)) {
			return;
		}
		let params = new HttpParams().set('id', this.id.toString());
		this.subscriptions.add(
			this.httpClient.delete<any>(this.deleteUrl, { params: params }).subscribe(result => {
				this.ApiReturn(result);
			})
		);
	}

	private GetUploadData(target: any) {
		const file: File = target.files[0];
		const uploadData: FormData = new FormData();
		uploadData.append('file', file, file.name);
		return uploadData;
	}

	private ApiReturn(result: any) {
		if (result.isSuccessful) {
			this.messageService.setSystemMessage(result.message);
			this.updateTable.emit();
			return;
		}
		this.messageService.setSystemMessage(result.message, 'error');
	}

	createSubstring(fileName: string) {
		if (fileName.length <= 10) {
			return fileName;
		}
		if (fileName.endsWith('csv')) {
			return this.GetShortedFileName(fileName, '...csv');
		} else if(fileName.endsWith('txt')) {
			return this.GetShortedFileName(fileName, '...txt');
		} else if(fileName.endsWith('pdf')) {
			return this.GetShortedFileName(fileName, '...pdf');
		}
		return this.GetShortedFileName(fileName, '...xlsx');
	}

	private GetShortedFileName(fileName: string, extension: string) {
		return fileName.replace(/\s/g, '').substring(0, 9) + extension;
	}
}
